const TransactionType = {
  USE_POINTS: 1,
  CHARGE_POINTS: 2,
  REFUND_POINTS: 3
}
export default TransactionType
